import React from 'react';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';

const Footer = () => {
  return (
    <footer style={{
      borderTop: '1px solid rgba(157, 78, 221, 0.2)',
      padding: '40px 20px 30px',
      marginTop: '80px',
      background: 'linear-gradient(180deg, transparent 0%, rgba(0, 0, 0, 0.3) 100%)'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '24px'
      }}>
        {/* Footer Links */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '32px',
          flexWrap: 'wrap'
        }}>
          <Link 
            to="/terms" 
            style={{
              color: '#999',
              textDecoration: 'none',
              fontSize: '14px',
              transition: 'color 0.2s'
            }}
            onMouseOver={(e) => e.currentTarget.style.color = '#9D4EDD'}
            onMouseOut={(e) => e.currentTarget.style.color = '#999'}
          >
            Terms & Conditions
          </Link>
          <Link 
            to="/privacy" 
            style={{
              color: '#999',
              textDecoration: 'none',
              fontSize: '14px',
              transition: 'color 0.2s'
            }}
            onMouseOver={(e) => e.currentTarget.style.color = '#9D4EDD'}
            onMouseOut={(e) => e.currentTarget.style.color = '#999'}
          >
            Privacy Policy
          </Link>
          <Link 
            to="/about" 
            style={{
              color: '#999',
              textDecoration: 'none',
              fontSize: '14px',
              transition: 'color 0.2s'
            }}
            onMouseOver={(e) => e.currentTarget.style.color = '#9D4EDD'}
            onMouseOut={(e) => e.currentTarget.style.color = '#999'}
          >
            About Us
          </Link>
          <Link 
            to="/contact" 
            style={{
              color: '#999',
              textDecoration: 'none',
              fontSize: '14px',
              transition: 'color 0.2s'
            }}
            onMouseOver={(e) => e.currentTarget.style.color = '#9D4EDD'}
            onMouseOut={(e) => e.currentTarget.style.color = '#999'}
          >
            Contact
          </Link>
        </div>

        {/* Copyright */}
        <div style={{
          textAlign: 'center',
          color: '#666',
          fontSize: '13px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px'
        }}>
          <span>© 2025 Mystic Temple, Inc</span>
          <span>•</span>
          <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            Made with <Heart size={14} fill="#9D4EDD" color="#9D4EDD" /> for your soul
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
